webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export fromName */
/* unused harmony export getName */
/* unused harmony export getDisplayName */
/* unused harmony export mapFromList */
function create(_ref) {
  var name = _ref.name,
      displayName = _ref.displayName;

  if (!displayName) {
    displayName = name;
  }
  return {
    name: name,
    displayName: displayName
  };
}

function fromName(name) {
  return create({ name: name });
}

function getName(category) {
  return category.name;
}

function getDisplayName(category) {
  return category.displayName;
}

function mapFromList(categories) {
  var categoriesMap = {};
  categories.forEach(function (c) {
    categoriesMap[c.name] = c;
  });
  return categoriesMap;
}

var ManipulationCategory = {
  mapFromList: mapFromList,
  create: create,
  fromName: fromName,
  getName: getName,
  getDisplayName: getDisplayName
};

/* harmony default export */ __webpack_exports__["a"] = (ManipulationCategory);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export getAnswerExplanationHTML */
/* unused harmony export getImageUrl */
/* unused harmony export getSourceName */
/* unused harmony export getSourceUrl */
/* unused harmony export getAnalysisName */
/* unused harmony export getAnalysisUrl */
/* unused harmony export isTrueNews */
/* unused harmony export isFalseNews */
/* unused harmony export isAnswered */
/* unused harmony export isAnsweredCorrectly */
/* unused harmony export isOmitted */
/* unused harmony export isOfManipulationCategory */
/* unused harmony export getManipulationCategoryName */
var create = function create(_ref) {
  var newsId = _ref.newsId,
      imageUrl = _ref.imageUrl,
      _ref$sourceName = _ref.sourceName,
      sourceName = _ref$sourceName === undefined ? '' : _ref$sourceName,
      _ref$sourceUrl = _ref.sourceUrl,
      sourceUrl = _ref$sourceUrl === undefined ? '' : _ref$sourceUrl,
      _ref$analysisName = _ref.analysisName,
      analysisName = _ref$analysisName === undefined ? '' : _ref$analysisName,
      _ref$analysisUrl = _ref.analysisUrl,
      analysisUrl = _ref$analysisUrl === undefined ? '' : _ref$analysisUrl,
      type = _ref.type,
      answerExplanationHTML = _ref.answerExplanationHTML,
      expectedAnswer = _ref.expectedAnswer;

  return {
    newsId: newsId,
    imageUrl: imageUrl,
    sourceName: sourceName,
    sourceUrl: sourceUrl,
    analysisName: analysisName,
    analysisUrl: analysisUrl,
    type: type,
    answer: null,
    answerExplanationHTML: answerExplanationHTML,
    expectedAnswer: expectedAnswer
  };
};

var getAnswerExplanationHTML = function getAnswerExplanationHTML(q) {
  return q.answerExplanationHTML;
};

var getImageUrl = function getImageUrl(q) {
  return q.imageUrl;
};

var getSourceName = function getSourceName(q) {
  return q.sourceName;
};

var getSourceUrl = function getSourceUrl(q) {
  return q.sourceUrl;
};

var getAnalysisName = function getAnalysisName(q) {
  return q.analysisName;
};

var getAnalysisUrl = function getAnalysisUrl(q) {
  return q.analysisUrl;
};

var isTrueNews = function isTrueNews(q) {
  return q.expectedAnswer === 'yes';
};

var isFalseNews = function isFalseNews(q) {
  return !isTrueNews(q);
};

var isAnswered = function isAnswered(q) {
  return !!q.answer;
};

var isAnsweredCorrectly = function isAnsweredCorrectly(q) {
  return q.answer === q.expectedAnswer;
};

var isOmitted = function isOmitted(q) {
  return !isAnswered(q);
};

function isOfManipulationCategory(question, manipulationCategory) {
  return question.type === manipulationCategory.name;
}

var getManipulationCategoryName = function getManipulationCategoryName(q) {
  return q.type;
};

var Question = {
  create: create,
  getAnswerExplanationHTML: getAnswerExplanationHTML,
  getImageUrl: getImageUrl,
  getSourceName: getSourceName,
  getSourceUrl: getSourceUrl,
  getAnalysisName: getAnalysisName,
  getAnalysisUrl: getAnalysisUrl,
  isTrueNews: isTrueNews,
  isFalseNews: isFalseNews,
  isAnswered: isAnswered,
  isAnsweredCorrectly: isAnsweredCorrectly,
  isOmitted: isOmitted,
  isOfManipulationCategory: isOfManipulationCategory,
  getManipulationCategoryName: getManipulationCategoryName
};

/* harmony default export */ __webpack_exports__["a"] = (Question);

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QUESTION_TIMEOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NUM_OF_QUIZ_QUESTIONS; });
/* unused harmony export ANSWERS_REVIEW_SCROLL_TOLERANCE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QUESTION_LANGUAGE; });
var QUESTION_TIMEOUT = 20 * 1000;
var NUM_OF_QUIZ_QUESTIONS = 16;
var ANSWERS_REVIEW_SCROLL_TOLERANCE = 40;
var QUESTION_LANGUAGE = 'en';

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export encode */
/* unused harmony export decode */
/* unused harmony export getUserName */
/* unused harmony export getCorrectnessEstimate */
/* unused harmony export getByManipulationCategory */
/* unused harmony export getNumOfAnswers */
/* unused harmony export getNumOfCorrectAnswers */
/* unused harmony export getNumOfOmittedAnswers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_collections__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__manipulation_category__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__quiz_setup_info__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user__ = __webpack_require__(50);







function create(_ref) {
  var quiz = _ref.quiz,
      user = _ref.user,
      quizSetupInfo = _ref.quizSetupInfo,
      manipulationCategories = _ref.manipulationCategories;

  var results = {
    version: 'v1',
    username: __WEBPACK_IMPORTED_MODULE_5__user__["a" /* default */].getName(user),
    est: __WEBPACK_IMPORTED_MODULE_4__quiz_setup_info__["a" /* default */].getCorrectnessEstimate(quizSetupInfo),
    total: quiz.questions.length,
    correct: countQuestionsByPredicate(quiz, __WEBPACK_IMPORTED_MODULE_3__question__["a" /* default */].isAnsweredCorrectly),
    omitted: countQuestionsByPredicate(quiz, __WEBPACK_IMPORTED_MODULE_3__question__["a" /* default */].isOmitted),
    byManipCat: {}
  };
  manipulationCategories.forEach(function (category) {
    var name = __WEBPACK_IMPORTED_MODULE_2__manipulation_category__["a" /* default */].getName(category);
    var isOfManipulationCategory = function isOfManipulationCategory(q) {
      return __WEBPACK_IMPORTED_MODULE_3__question__["a" /* default */].isOfManipulationCategory(q, category);
    };
    var total = countQuestionsByPredicate(quiz, isOfManipulationCategory);
    var correct = countQuestionsByPredicate(quiz, function (q) {
      return isOfManipulationCategory(q) && __WEBPACK_IMPORTED_MODULE_3__question__["a" /* default */].isAnsweredCorrectly(q);
    });
    var omitted = countQuestionsByPredicate(quiz, function (q) {
      return isOfManipulationCategory(q) && __WEBPACK_IMPORTED_MODULE_3__question__["a" /* default */].isOmitted(q);
    });
    results.byManipCat[name] = {
      total: total,
      correct: correct,
      omitted: omitted
    };
  });
  return results;
}

function encode(resultStats) {
  var resultsStatsJSON = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resultStats);
  var resultsStatsPayload = btoa(resultsStatsJSON);
  return resultsStatsPayload;
}

function decode(resultStatsPayload) {
  var resultStatsJSON = atob(resultStatsPayload);
  var resultStats = JSON.parse(resultStatsJSON);
  return resultStats;
}

function getUserName(resultStats) {
  return resultStats.username;
}

function getCorrectnessEstimate(resultStats) {
  return resultStats.est;
}

function getByManipulationCategory(resultStats, manipulationCategory) {
  return resultStats.byManipCat[manipulationCategory.name];
}

function getNumOfAnswers(stats) {
  return stats.total;
}

function getNumOfCorrectAnswers(stats) {
  return stats.correct;
}

function getNumOfOmittedAnswers(stats) {
  return stats.omitted;
}

function countQuestionsByPredicate(quiz, predicate) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_collections__["a" /* countByPredicate */])(quiz.questions, predicate);
}

var ResultStats = {
  create: create,
  encode: encode,
  decode: decode,
  getUserName: getUserName,
  getCorrectnessEstimate: getCorrectnessEstimate,
  getByManipulationCategory: getByManipulationCategory,
  getNumOfAnswers: getNumOfAnswers,
  getNumOfCorrectAnswers: getNumOfCorrectAnswers,
  getNumOfOmittedAnswers: getNumOfOmittedAnswers
};

/* harmony default export */ __webpack_exports__["a"] = (ResultStats);

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  mounted: function mounted() {
    // test for touch events support and if not supported, attach .no-touch class to the HTML tag.
    if (!('ontouchstart' in document.documentElement)) {
      document.documentElement.className += ' no-touch';
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_location__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Intro',
  data: function data() {
    return {
      page: 1,
      userInfo: {
        name: '',
        prediction: 50,
        category: ''
      },
      validationError: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isQuizLoaded']), {
    pageTransitions: function pageTransitions() {
      return {
        6: {
          canGoNext: function canGoNext() {
            return this.userInfo.category !== '';
          },
          next: function next() {
            this.setUserInfo(this.userInfo);
            this.generateQuiz();
          }
        },
        7: {
          canGoNext: function canGoNext() {
            return this.isQuizLoaded;
          },
          next: function next() {
            this.startQuiz();
          }
        }
      };
    },
    incrementPageEnabled: function incrementPageEnabled() {
      var pageTransition = this.pageTransitions[this.page];
      if (pageTransition && pageTransition.canGoNext) {
        return pageTransition.canGoNext.call(this);
      }
      return true;
    },
    incrementPageDisabled: function incrementPageDisabled() {
      return !this.incrementPageEnabled;
    },
    incrementPageButtonText: function incrementPageButtonText() {
      if (this.page === 1) {
        return 'OK, SHOW ME THE TRICKS';
      }
      if (this.page === 7) {
        if (this.isQuizLoaded) {
          return 'I AM, LET’S DO IT!';
        } else {
          return 'Loading...';
        }
      }
      return 'next';
    },
    incrementPageButtonClass: function incrementPageButtonClass() {
      if (this.page === 7) {
        return 'blue';
      }
      return 'opaque-blue';
    },
    questionTimeoutInSeconds: function questionTimeoutInSeconds() {
      return __WEBPACK_IMPORTED_MODULE_3__consts__["c" /* QUESTION_TIMEOUT */] / 1000;
    },
    numOfQuizQuestions: function numOfQuizQuestions() {
      return Object({"NODE_ENV":"production","BUILD_ENV":"production","GOOGLE_ANALYTICS_TRACKER_ID":"UA-156092120-1","BACKEND_HOST":"fzw-backend.herokuapp.com","BACKEND_HTTP_SCHEME":"https","APP_HOST":"aplikacja.fajniezewiesz.pl","APP_HTTP_SCHEME":"https"}).NUM_OF_QUIZ_QUESTIONS || __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* NUM_OF_QUIZ_QUESTIONS */];
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.pingBackend();
    this.fetchManipulationCategories().then(function () {
      var queryParams = Object(__WEBPACK_IMPORTED_MODULE_2__utils_location__["a" /* parseQuery */])(window.location.search);
      if (queryParams.results) {
        _this.$router.replace({
          name: 'Results',
          params: queryParams
        });
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['generateQuiz', 'pingBackend', 'fetchManipulationCategories']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['setUserInfo']), {
    incrementPage: function incrementPage() {
      var pageTransition = this.pageTransitions[this.page];
      ++this.page;
      if (pageTransition && pageTransition.next) {
        pageTransition.next.call(this);
      }
    },
    startQuiz: function startQuiz() {
      localStorage.setItem('category', this.userInfo.category);
      this.$router.push('/quiz');
    }
  })
});

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PieChart__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_QuestCard__ = __webpack_require__(46);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Quest',
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_3__components_PieChart__["a" /* default */],
    QuestCard: __WEBPACK_IMPORTED_MODULE_4__components_QuestCard__["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    document.body.classList.add('dark');
    next(function (vm) {
      vm.startQuestionTimeout();
      vm.startTicker();
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.stopQuestionTimeout();
    this.stopTicker();
    next();
  },

  data: function data() {
    return {
      tick: Date.now(),
      buttonsDisabled: false
    };
  },
  computed: {
    question: function question() {
      return this.$store.getters.currentQuizQuestion;
    },
    questions: function questions() {
      return this.$store.getters.quizQuestions;
    },
    questionIndex: function questionIndex() {
      return this.$store.getters.quizQuestionIndex;
    },
    questionNumber: function questionNumber() {
      return this.$store.getters.quizQuestionIndex + 1;
    },
    countdownSeconds: function countdownSeconds() {
      var delta = this.tick - this.questionStartTime;
      return Math.ceil((__WEBPACK_IMPORTED_MODULE_2__consts__["c" /* QUESTION_TIMEOUT */] - delta) / 1000);
    },
    questionTimeoutSeconds: function questionTimeoutSeconds() {
      return __WEBPACK_IMPORTED_MODULE_2__consts__["c" /* QUESTION_TIMEOUT */] / 1000;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['answerQuizQuestion', 'omitQuizQuestion']), {
    disableButtons: function disableButtons() {
      this.buttonsDisabled = true;
    },
    enableButtons: function enableButtons() {
      this.buttonsDisabled = false;
    },
    answerTrueNews: function answerTrueNews() {
      this.answer('yes');
    },
    answerFalseNews: function answerFalseNews() {
      this.answer('no');
    },
    answer: function answer(a) {
      this.answerQuestionOrEndQuiz(a);
    },
    afterEnter: function afterEnter() {
      this.enableButtons();
    },
    leave: function leave() {
      this.disableButtons();
    },
    answerQuestionOrEndQuiz: function answerQuestionOrEndQuiz(answer) {
      this.stopQuestionTimeout();
      this.answerQuizQuestion({
        answer: answer
      });
      this.disableButtons();
      if (this.$store.getters.isQuizFinished) {
        this.goToResults();
      } else {
        this.startQuestionTimeout();
      }
    },
    omitQuestionOrEndQuiz: function omitQuestionOrEndQuiz() {
      this.omitQuizQuestion();
      if (this.$store.getters.isQuizFinished) {
        this.goToResults();
      } else {
        this.startQuestionTimeout();
      }
    },
    goToResults: function goToResults() {
      this.$router.push('/results');
    },
    stopQuestionTimeout: function stopQuestionTimeout() {
      clearTimeout(this.questionTimeout);
    },
    startQuestionTimeout: function startQuestionTimeout() {
      var _this = this;

      clearTimeout(this.questionTimeout);
      this.questionStartTime = Date.now();
      this.questionTimeout = setTimeout(function () {
        _this.omitQuestionOrEndQuiz();
      }, __WEBPACK_IMPORTED_MODULE_2__consts__["c" /* QUESTION_TIMEOUT */]);
    },
    startTicker: function startTicker() {
      var _this2 = this;

      this.tickInterval = setInterval(function () {
        _this2.tick = Date.now();
      }, 100);
    },
    stopTicker: function stopTicker() {
      clearInterval(this.tickInterval);
    }
  })
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PieChart',
  props: {
    numerator: {
      type: Number,
      required: true
    },
    denominator: {
      type: Number,
      required: true
    },
    textPercent: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      r: 100 / this.denominator,
      total: 100
    };
  },

  computed: {
    score: function score() {
      return this.numerator * this.r;
    },
    percent: function percent() {
      return Math.floor(this.numerator / this.denominator * 100);
    },
    counterText: function counterText() {
      if (this.textPercent && this.denominator > 0) {
        return this.percent + '%';
      } else if (!this.textPercent) {
        return this.numerator;
      } else {
        return 'N/A';
      }
    },
    points: function points() {
      var points = { s: '', t: '' };
      var x = void 0,
          y = void 0,
          angle = void 0;
      for (var i = 0; i < this.total + 1; i++) {
        angle = Math.PI * 2 / this.total * i;
        x = 25 + 20 * Math.cos(angle + Math.PI / 2);
        y = 25 + 20 * -Math.sin(angle + Math.PI / 2);
        points.t += x + ',' + y + ' ';
        if (this.score >= i) {
          points.s = points.t;
        }
      }
      return points;
    }
  },
  created: function created() {}
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestCard_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be372f0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestCard_vue__ = __webpack_require__(108);
function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be372f0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be372f0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QuestCard',
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  computed: {
    answerClass: function answerClass() {
      if (this.question.answer === 'yes') {
        return 'answer-true';
      } else if (this.question.answer === 'no') {
        return 'answer-false';
      }
      return null;
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_result_stats__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Results',
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    document.body.classList.add('dark');
    next();
  },
  data: function data() {
    return {
      emo: false,
      bait: false,
      lie: false,
      manipulation: false
    };
  },

  computed: {
    resultStats: function resultStats() {
      var routeResultStatsPayload = this.$route.params.results;
      if (routeResultStatsPayload) {
        // load results from url
        return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].decode(routeResultStatsPayload);
      } else {
        return this.$store.getters.resultStats;
      }
    },
    resultStatsEmoLang: function resultStatsEmoLang() {
      return this.getManipulationCategoryResultStats('emotional-language');
    },
    resultStatsClickbait: function resultStatsClickbait() {
      return this.getManipulationCategoryResultStats('clickbait');
    },
    resultStatsFakeNews: function resultStatsFakeNews() {
      return this.getManipulationCategoryResultStats('fake-news');
    },
    resultStatsImgManip: function resultStatsImgManip() {
      return this.getManipulationCategoryResultStats('image-manipulation');
    },
    correctnessBetterThanEstimated: function correctnessBetterThanEstimated() {
      return this.correctness > this.correctnessEstimate;
    },
    correctnessWorseThanEstimated: function correctnessWorseThanEstimated() {
      return this.correctness < this.correctnessEstimate;
    },
    correctnessPercent: function correctnessPercent() {
      return Math.floor(this.numOfCorrectAnswers / this.numOfQuestions * 100);
    },
    correctnessEstimatePercent: function correctnessEstimatePercent() {
      return Math.floor(this.correctnessEstimate * 100);
    },
    correctness: function correctness() {
      return this.numOfCorrectAnswers / this.numOfQuestions;
    },
    correctnessEstimate: function correctnessEstimate() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getCorrectnessEstimate(this.resultStats);
    },
    numOfQuestions: function numOfQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfAnswers(this.resultStats);
    },
    numOfCorrectAnswers: function numOfCorrectAnswers() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfCorrectAnswers(this.resultStats);
    },
    numOfEmotionalLanguageQuestions: function numOfEmotionalLanguageQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfAnswers(this.resultStatsEmoLang);
    },
    numOfCorrectEmotionalLanguageAnswers: function numOfCorrectEmotionalLanguageAnswers() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfCorrectAnswers(this.resultStatsEmoLang);
    },
    numOfClickbaitQuestions: function numOfClickbaitQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfAnswers(this.resultStatsClickbait);
    },
    numOfCorrectClickbaitAnswers: function numOfCorrectClickbaitAnswers() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfCorrectAnswers(this.resultStatsClickbait);
    },
    numOfFakeNewsQuestions: function numOfFakeNewsQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfAnswers(this.resultStatsFakeNews);
    },
    numOfCorrectFakeNewsAnswers: function numOfCorrectFakeNewsAnswers() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfCorrectAnswers(this.resultStatsFakeNews);
    },
    numOfImageManipulationQuestions: function numOfImageManipulationQuestions() {
      return this.resultStatsImgManip.total;
    },
    numOfCorrectImageManipulationAnswers: function numOfCorrectImageManipulationAnswers() {
      return this.resultStatsImgManip.correct;
    },
    username: function username() {
      return this.resultStats.username;
    },
    title: function title() {
      return this.titleAndDescription[0];
    },
    description: function description() {
      return this.titleAndDescription[1];
    },
    titleAndDescription: function titleAndDescription() {
      var ratio = this.numOfCorrectAnswers / this.numOfQuestions;

      if (ratio >= 16 / 16) {
        return ['PHENOMENAL WORK!', 'You sure know how to tell the truth from falsehoods!'];
      } else if (ratio >= 12 / 16) {
        return ['WELL DONE!', 'A tiny bit more practice and you won’t be fooled ever again!'];
      } else if (ratio >= 9 / 16) {
        return ['NOT BAD', 'You can’t always tell the truth from falsehoods. Practice and play one more time!'];
      } else if (ratio >= 5 / 16) {
        return ['THERE’S ROOM FOR IMPROVEMENT', 'You know a thing or two about fake news,' + ' but you need to improve your ability to spot it.' + ' Check out your answers and play again!'];
      }
      return ['PRACTICE CRITICAL THINKING', 'You could have done much better. Check out your incorrect answers and' + ' make sure you read the explanations to understand each mistake.' + ' Play again to beat your score!'];
    }
  },
  methods: {
    getManipulationCategoryResultStats: function getManipulationCategoryResultStats(categoryName) {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getByManipulationCategory(this.resultStats, __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].fromName(categoryName));
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export getCorrectnessEstimate */
/* unused harmony export getTopicCategory */
/* unused harmony export setValues */
function create(_ref) {
  var _ref$topicCategory = _ref.topicCategory,
      topicCategory = _ref$topicCategory === undefined ? null : _ref$topicCategory,
      _ref$correctnessEstim = _ref.correctnessEstimate,
      correctnessEstimate = _ref$correctnessEstim === undefined ? 1.0 : _ref$correctnessEstim;

  return {
    topicCategory: topicCategory,
    correctnessEstimate: correctnessEstimate
  };
}

function getCorrectnessEstimate(quizSetupInfo) {
  return quizSetupInfo.correctnessEstimate;
}

function getTopicCategory(quizSetupInfo) {
  return quizSetupInfo.topicCategory;
}

function setValues(quizSetupInfo, _ref2) {
  var topicCategory = _ref2.topicCategory,
      correctnessEstimate = _ref2.correctnessEstimate;

  if (typeof topicCategory !== 'undefined') {
    quizSetupInfo.topicCategory = topicCategory;
  }
  if (typeof correctnessEstimate !== 'undefined') {
    quizSetupInfo.correctnessEstimate = correctnessEstimate;
  }
}

var QuizSetupInfo = {
  create: create,
  getCorrectnessEstimate: getCorrectnessEstimate,
  getTopicCategory: getTopicCategory,
  setValues: setValues
};

/* harmony default export */ __webpack_exports__["a"] = (QuizSetupInfo);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export getName */
/* unused harmony export setName */
function create(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === undefined ? 'test' : _ref$name;

  return {
    name: name
  };
}

function getName(user) {
  return user.name;
}

function setName(user, name) {
  user.name = name;
}

var User = {
  create: create,
  getName: getName,
  setName: setName
};

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_QuestCard__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FootLinkNote__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_question__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AnswersReview',
  components: {
    QuestCard: __WEBPACK_IMPORTED_MODULE_0__components_QuestCard__["a" /* default */],
    FootLinkNote: __WEBPACK_IMPORTED_MODULE_1__components_FootLinkNote__["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    document.body.classList.remove('dark');
    next();
  },
  data: function data() {
    return {
      questionIndex: 0,
      scrollOffset: 0,
      maxScrollOffset: 0,
      answerTypesDict: {
        'nothing': {
          className: 'no-answer',
          text: 'No answer',
          icon: '☹', // https://www.utf8icons.com/character/9785/white-frowning-face
          iconClassName: 'no-answer'
        },
        'correct': {
          className: 'correct-answer',
          text: 'Correct answer!',
          icon: '✓',
          iconClassName: 'circle-icon correct-answer-circle'
        },
        'wrong': {
          className: 'wrong-answer',
          text: 'Incorrect answer',
          icon: '×',
          iconClassName: 'circle-icon wrong-answer-circle'
        }
      }
    };
  },

  computed: {
    nextAnswerEnabled: function nextAnswerEnabled() {
      return true;
    },
    nextAnswerText: function nextAnswerText() {
      if (this.nextAnswerEnabled) {
        return 'next';
      } else {
        return 'scroll down';
      }
    },
    newsIsTrue: function newsIsTrue() {
      if (this.question.expectedAnswer === 'yes') {
        return true;
      } else if (this.question.expectedAnswer === 'no') {
        return false;
      }
      return null;
    },
    answerExplanationHTML: function answerExplanationHTML() {
      return __WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].getAnswerExplanationHTML(this.question);
    },
    answerType: function answerType() {
      var answerTypeString = void 0;
      if (!__WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].isAnswered(this.question)) {
        answerTypeString = 'nothing';
      } else if (__WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].isAnsweredCorrectly(this.question)) {
        answerTypeString = 'correct';
      } else {
        answerTypeString = 'wrong';
      }
      return this.answerTypesDict[answerTypeString];
    },
    sourceUrl: function sourceUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].getSourceUrl(this.question);
    },
    sourceName: function sourceName() {
      return __WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].getSourceName(this.question);
    },
    analysisUrl: function analysisUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].getAnalysisUrl(this.question);
    },
    analysisName: function analysisName() {
      return __WEBPACK_IMPORTED_MODULE_2__data_question__["a" /* default */].getAnalysisName(this.question);
    },
    question: function question() {
      return this.questions[this.questionIndex];
    },
    questions: function questions() {
      return this.$store.getters.quizQuestions;
    }
  },
  mounted: function mounted() {
    this.updateScrollData();
  },

  methods: {
    calculateScrollData: function calculateScrollData() {
      var container = this.$refs.container;
      if (!container) {
        return { scrollOffset: 0, maxScrollOffset: 0 };
      }
      var containerHeight = container.getBoundingClientRect().height;
      var scrollOffset = container.scrollTop - container.offsetTop;
      var maxScrollOffset = container.scrollHeight - containerHeight;
      return { scrollOffset: scrollOffset, maxScrollOffset: maxScrollOffset };
    },
    updateScrollData: function updateScrollData() {
      var _calculateScrollData = this.calculateScrollData(),
          scrollOffset = _calculateScrollData.scrollOffset,
          maxScrollOffset = _calculateScrollData.maxScrollOffset;

      this.scrollOffset = scrollOffset;
      this.maxScrollOffset = maxScrollOffset;
    },
    scrollToTop: function scrollToTop() {
      var container = this.$refs.container;
      if (!container) {
        return;
      }
      container.scrollTo(0, 0);
    },
    goToNextAnswer: function goToNextAnswer() {
      var _this = this;

      this.questionIndex += 1;
      if (this.questionIndex >= this.$store.getters.numOfQuizQuestions) {
        this.goToSummary();
      } else {
        this.scrollToTop();
        this.$nextTick(function () {
          // Update scrollData when changes are propagated to DOM just in case.
          _this.updateScrollData();
        });
      }
    },
    goToSummary: function goToSummary() {
      var path = '/summary';
      if (window.localStorage.getItem('category') === 'vaccinations') {
        path = '/unicef';
      }

      this.$router.push(path);
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FootLinkNote',
  props: {
    name: {
      type: String,
      required: true
    },
    linkName: {
      type: String,
      required: true,
      default: ''
    },
    linkUrl: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    linkNameText: function linkNameText() {
      if (!this.linkName && this.linkUrl) {
        return 'link';
      }
      return this.linkName;
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary'
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SummaryUnicef'
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_result_stats__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShareResults',
  data: function data() {
    return {
      rated: false
    };
  },
  computed: {
    resultStats: function resultStats() {
      return this.$store.getters.resultStats;
    },
    resultsUrl: function resultsUrl() {
      var _window$location = window.location,
          protocol = _window$location.protocol,
          host = _window$location.host;


      var statsPayload = __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].encode(this.resultStats);
      var url = protocol + '//' + host + '/?results=' + statsPayload;
      return url;
    },
    appUrl: function appUrl() {
      var _window$location2 = window.location,
          protocol = _window$location2.protocol,
          host = _window$location2.host;


      var url = protocol + '//' + host + '/';
      return url;
    },
    correctnessPercent: function correctnessPercent() {
      return Math.floor(this.numOfCorrectAnswers / this.numOfQuestions * 100);
    },
    numOfQuestions: function numOfQuestions() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfAnswers(this.resultStats);
    },
    numOfCorrectAnswers: function numOfCorrectAnswers() {
      return __WEBPACK_IMPORTED_MODULE_0__data_result_stats__["a" /* default */].getNumOfCorrectAnswers(this.resultStats);
    }
  },
  methods: {
    shareResults: function shareResults() {
      var url = this.appUrl;
      var fbShareUrl = 'http://www.facebook.com/sharer.php?u=' + encodeURIComponent(url);
      window.open(fbShareUrl, 'sharer', 'toolbar=0,status=0,width=626,height=436');
    },
    sendRate: function sendRate() {
      var rate = document.querySelector('input[name="rating"]:checked').value;
      // eslint-disable-next-line no-undef
      gtag('event', 'rate_app', {
        'event_category': 'feedback',
        'event_label': 'fzw-webapp',
        'value': rate
      });
      this.rated = true;
    }
  }
});

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(67);


var _process$env = Object({"NODE_ENV":"production","BUILD_ENV":"production","GOOGLE_ANALYTICS_TRACKER_ID":"UA-156092120-1","BACKEND_HOST":"fzw-backend.herokuapp.com","BACKEND_HTTP_SCHEME":"https","APP_HOST":"aplikacja.fajniezewiesz.pl","APP_HTTP_SCHEME":"https"}),
    BACKEND_HTTP_SCHEME = _process$env.BACKEND_HTTP_SCHEME,
    BACKEND_HOST = _process$env.BACKEND_HOST;

var API_BASE_URL = BACKEND_HTTP_SCHEME + '://' + BACKEND_HOST + '/api/v1/';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].create({
  baseURL: API_BASE_URL
}));

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios);

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export getId */
/* unused harmony export getCurrentQuestion */
/* unused harmony export getQuestions */
/* unused harmony export getQuestionIndex */
/* unused harmony export isFinished */
/* unused harmony export answerQuestion */
/* unused harmony export omitQuestion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__question__ = __webpack_require__(18);


function create(_ref) {
  var id = _ref.id,
      _ref$questions = _ref.questions,
      questions = _ref$questions === undefined ? [] : _ref$questions;

  return {
    id: id,
    questionIndex: 0,
    questions: questions.map(__WEBPACK_IMPORTED_MODULE_0__question__["a" /* default */].create)
  };
}

function getId(quiz) {
  return quiz.id;
}

function getCurrentQuestion(quiz) {
  return quiz.questions[quiz.questionIndex];
}

function getQuestions(quiz) {
  return quiz.questions;
}

function getQuestionIndex(quiz) {
  return quiz.questionIndex;
}

function isFinished(quiz) {
  return quiz.questionIndex >= quiz.questions.length;
}

function answerQuestion(quiz, answer) {
  if (isFinished(quiz)) {
    return;
  }
  quiz.questions[quiz.questionIndex].answer = answer;
  quiz.questionIndex++;
}

function omitQuestion(quiz) {
  if (isFinished(quiz)) {
    return;
  }
  quiz.questionIndex++;
}

var Quiz = {
  create: create,
  getId: getId,
  getCurrentQuestion: getCurrentQuestion,
  getQuestions: getQuestions,
  getQuestionIndex: getQuestionIndex,
  isFinished: isFinished,
  answerQuestion: answerQuestion,
  omitQuestion: omitQuestion
};

/* harmony default export */ __webpack_exports__["a"] = (Quiz);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export create */
/* unused harmony export fromName */
/* unused harmony export getName */
/* unused harmony export getDisplayName */
function create(_ref) {
  var name = _ref.name,
      displayName = _ref.displayName;

  if (!displayName) {
    displayName = name;
  }
  return {
    name: name,
    displayName: displayName
  };
}

function fromName(name) {
  return create({ name: name });
}

function getName(category) {
  return category.name;
}

function getDisplayName(category) {
  return category.displayName;
}

var TopicCategory = {
  create: create,
  fromName: fromName,
  getName: getName,
  getDisplayName: getDisplayName
};

/* harmony default export */ __webpack_exports__["a"] = (TopicCategory);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__(67);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});

// In abstract router mode we must set the initial location explicitly:
/// https://github.com/vuejs/vue-router/issues/729
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/');

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a440d65_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(84);
function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a440d65_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Intro__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Quest__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Results__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AnswersReview__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Summary__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SummaryUnicef__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ShareResults__ = __webpack_require__(128);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'abstract',
  routes: [{
    path: '/',
    name: 'Intro',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Intro__["a" /* default */]
  }, {
    path: '/quiz',
    name: 'Quiz',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Quest__["a" /* default */]
  }, {
    path: '/results',
    name: 'Results',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Results__["a" /* default */]
  }, {
    path: '/answers-review',
    name: 'AnswersReview',
    component: __WEBPACK_IMPORTED_MODULE_5__components_AnswersReview__["a" /* default */]
  }, {
    path: '/summary',
    name: 'Summary',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Summary__["a" /* default */]
  }, {
    path: '/unicef',
    name: 'Unicef',
    component: __WEBPACK_IMPORTED_MODULE_7__components_SummaryUnicef__["a" /* default */]
  }, {
    path: '/share-results',
    name: 'ShareResults',
    component: __WEBPACK_IMPORTED_MODULE_8__components_ShareResults__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  var fakePath = '/#' + to.path;
  // eslint-disable-next-line no-undef
  gtag('event', 'page_view', {
    page_title: to.name,
    page_path: fakePath
  });

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_744d9a9b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__ = __webpack_require__(101);
function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-744d9a9b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_744d9a9b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseQuery;
var decode = decodeURIComponent;

// Copied from vue-router utils
function parseQuery(query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res;
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"intro"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 1),expression:"page === 1"}]},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("\n      Find out what’s hidden behind the term fake news and learn to\n      recognize any fakes that come your way.\n      There are a few tricks of the trade worth knowing if you don’t\n      want to get lost in the world of omnipresent misinformation.\n      The tricks will also help you navigate the game.\n    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 2),expression:"page === 2"}]},[_vm._m(2),_vm._v(" "),_c('h1',[_vm._v("\n      FAKE NEWS: WHAT IS IT?\n    ")]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 3),expression:"page === 3"}]},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 4),expression:"page === 4"}]},[_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 5),expression:"page === 5"}]},[_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 6),expression:"page === 6"}]},[_c('div',{attrs:{"id":"category-selection"}},[_c('h1',[_vm._v("Pick the topic you want to explore in the quiz")]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"all","type":"radio","value":"all"},domProps:{"checked":_vm._q(_vm.userInfo.category,"all")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "all")}}}),_vm._v(" "),_vm._m(13)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"entertainment","type":"radio","value":"entertainment-en"},domProps:{"checked":_vm._q(_vm.userInfo.category,"entertainment-en")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "entertainment-en")}}}),_vm._v(" "),_vm._m(14)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"health","type":"radio","value":"health-en"},domProps:{"checked":_vm._q(_vm.userInfo.category,"health-en")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "health-en")}}}),_vm._v(" "),_vm._m(15)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"nauka","type":"radio","value":"science-en"},domProps:{"checked":_vm._q(_vm.userInfo.category,"science-en")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "science-en")}}}),_vm._v(" "),_vm._m(16)]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.category),expression:"userInfo.category"}],attrs:{"id":"polityka","type":"radio","value":"politics-en"},domProps:{"checked":_vm._q(_vm.userInfo.category,"politics-en")},on:{"change":function($event){_vm.$set(_vm.userInfo, "category", "politics-en")}}}),_vm._v(" "),_vm._m(17)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.page === 7),expression:"page === 7"}]},[_vm._m(18),_vm._v(" "),_c('h1',[_vm._v("ALMOST THERE! ")]),_vm._v(" "),_c('p',[_vm._v("\n      You are going to take the quiz with "+_vm._s(_vm.numOfQuizQuestions)+"\n      examples of content published online.\n      "),_c('b',[_vm._v("\n        Follow your gut feeling and decide which example represents\n        fake news by clicking on either FAKE or TRUE.\n      ")]),_vm._v("\n      Examples change every "+_vm._s(_vm.questionTimeoutInSeconds)+" seconds,\n      which means this is how much time you have to\n      make a decision. So, are you ready?\n    ")])]),_vm._v(" "),_c('button',{class:_vm.incrementPageButtonClass,attrs:{"disabled":_vm.incrementPageDisabled},on:{"click":_vm.incrementPage}},[_vm._v("\n    "+_vm._s(_vm.incrementPageButtonText)+"\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/hello.png","alt":"hello"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      HI THERE!"),_c('br'),_vm._v("\n      WELCOME ON BOARD :)\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/fake_news.png","alt":"fake news"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("\n        Fake news is any piece of false information presented as true\n        and spread online or by means of traditional media outlets.\n      ")]),_vm._v("\n      It is usually created with an aim to reach\n      a certain political, financial or personal goal.\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/source.png","alt":"source"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      FIRST – "),_c('br'),_vm._v("\n      CHECK SOURCES\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      While browsing through posts and articles on social media make\n      sure you always check their source. False websites\n      are often openly satirical or disguised as trustworthy.\n      "),_c('b',[_vm._v("Stay alert to the name and design of a website.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/graphics.png","alt":"graphics"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      SECOND – "),_c('br'),_vm._v("\n      EXAMINE IMAGES\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      An image that accompanies an article or a meme can also\n      be misleading. Before you decide that what you are\n      looking at is true and share it with others,\n      "),_c('b',[_vm._v("\n        make sure that the piece fits the context or that the\n        quote it carries is an actual quote.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/emotions.png","alt":"emotions"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      THIRD – "),_c('br'),_vm._v("\n      DON’T JUST CLICK, READ!\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      False information is spread with an aim to make you feel\n      strong emotions, which in turn make you click on a link\n      or a post. Why? Because clicks are money!\n      "),_c('b',[_vm._v("\n        Pay attention to any content that provokes emotions,\n        includes numerous exclamation marks, or has all capital titles.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"all"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/world.svg","alt":""}})]),_c('div',[_vm._v("Surprise me!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"entertainment"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/fireworks.svg","alt":""}})]),_c('div',[_vm._v("Entertainment")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"health"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/doctor.svg","alt":""}})]),_c('div',[_vm._v("Health")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"nauka"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/atom.svg","alt":""}})]),_c('div',[_vm._v("Science")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"polityka"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"static/img/white-house.svg","alt":""}})]),_c('div',[_vm._v("Politics")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/lets_begin.png","alt":"let's begin"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quest_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fab06b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quest_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9fab06b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fab06b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbbbe8f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PieChart_vue__ = __webpack_require__(106);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bbbbe8f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbbbe8f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PieChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('text',{style:({ fill: 'white'}),attrs:{"x":"25","y":25,"font-size":_vm.textPercent ? 13 : 17}},[_vm._v("\n      "+_vm._s(_vm.counterText)+"\n    ")]),_vm._v(" "),_c('polyline',{style:({ stroke: '#ddd', opacity: '15%' }),attrs:{"points":_vm.points.t}}),_vm._v(" "),_c('polyline',{style:({ stroke: '#EF420C'}),attrs:{"points":_vm.points.s}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:['card', 'img', _vm.answerClass],attrs:{"src":_vm.question.imageUrl,"alt":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",staticStyle:{"overflow":"hidden","background-image":"url('static/img/question-bg.png')"},attrs:{"id":"quest"}},[_c('PieChart',{attrs:{"id":"counter","numerator":_vm.countdownSeconds,"denominator":_vm.questionTimeoutSeconds,"text-percent":false}}),_vm._v(" "),_c('ul',{staticClass:"progress"},_vm._l((_vm.questions),function(q,index){return _c('li',{key:q.newsId,class:{ active: index === _vm.questionIndex }})})),_vm._v(" "),_vm._l((_vm.questions),function(q,index){return _c('transition',{key:q.newsId,attrs:{"name":"question-transition"},on:{"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_c('QuestCard',{directives:[{name:"show",rawName:"v-show",value:(index === _vm.questionIndex),expression:"index === questionIndex"}],attrs:{"question":q}})],1)}),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"opaque-white answer",attrs:{"disabled":_vm.buttonsDisabled},on:{"click":function($event){_vm.answerFalseNews()}}},[_vm._v("\n      Fake\n    ")]),_vm._v(" "),_c('button',{staticClass:"opaque-white answer",attrs:{"disabled":_vm.buttonsDisabled},on:{"click":function($event){_vm.answerTrueNews()}}},[_vm._v("\n      True\n    ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fccce42c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__ = __webpack_require__(115);
function injectStyle (ssrContext) {
  __webpack_require__(111)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fccce42c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fccce42c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countByPredicate; });
var countByPredicate = function countByPredicate(arr, predicate) {
  return arr.reduce(function (acc, v) {
    return predicate(v) ? acc + 1 : acc;
  }, 0);
};

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"results"}},[_c('div',{},[_vm._m(0),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v("\n      You scored "+_vm._s(_vm.numOfCorrectAnswers)+" out of "+_vm._s(_vm.numOfQuestions)+"\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")])]),_vm._v(" "),_c('router-link',{staticClass:"opaque-white",attrs:{"tag":"button","type":"button","name":"button","to":"/answers-review"}},[_vm._v("\n    Check out your answers\n  ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('img',{attrs:{"src":"static/img/results.png","alt":"source"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnswersReview_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4cb8caa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnswersReview_vue__ = __webpack_require__(121);
function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4cb8caa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnswersReview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4cb8caa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnswersReview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FootLinkNote_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af467e10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FootLinkNote_vue__ = __webpack_require__(120);
function injectStyle (ssrContext) {
  __webpack_require__(119)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af467e10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FootLinkNote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af467e10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FootLinkNote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkNameText)?_c('p',{staticClass:"foot-link-note"},[_vm._v("\n  "+_vm._s(_vm.name)+":\n  "),(_vm.linkUrl)?_c('span',[_c('a',{attrs:{"href":_vm.linkUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.linkNameText))])]):_c('span',[_vm._v("\n    "+_vm._s(_vm.linkNameText)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"app-container",attrs:{"id":"answers-review"},on:{"scroll":_vm.updateScrollData}},[_c('div',{staticClass:"content-container"},[_c('ul',{staticClass:"progress"},_vm._l((_vm.questions),function(q,index){return _c('li',{key:q.newsId,class:{ active: index === _vm.questionIndex }})})),_vm._v(" "),_c('h1',{domProps:{"textContent":_vm._s(_vm.answerType.text)}}),_vm._v(" "),_c('quest-card',{attrs:{"question":_vm.question}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.question.answerExplanationHTML)}}),_vm._v(" "),_c('div',{staticClass:"foot-link-notes"},[_c('foot-link-note',{attrs:{"name":"Source","link-name":_vm.sourceName,"link-url":_vm.sourceUrl}}),_vm._v(" "),_c('foot-link-note',{attrs:{"name":"Explanation","link-name":_vm.analysisName,"link-url":_vm.analysisUrl}})],1),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"opaque-blue",attrs:{"disabled":!_vm.nextAnswerEnabled,"type":"button","name":"button"},on:{"click":function($event){_vm.goToNextAnswer()}}},[_vm._v("\n        "+_vm._s(_vm.nextAnswerText)+"\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_622f37be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__(124);
function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-622f37be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_622f37be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"summary"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('router-link',{staticClass:"opaque-blue",attrs:{"tag":"button","type":"button","name":"button","to":"/share-results"}},[_vm._v("\n      Next\n    ")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Fakes? No, thanks!")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("\n        We hope you are now ready to spot fake news.\n        Make sure you remember about these key rules while reading online content!\n      ")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n        Inspect closely any suspicious and unknown sources of information.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        Remember that photographs or memes embedded in an article can also be fake or manipulated.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        Pay special attention to extremely emotional content,\n        numerous exclamation and quotation marks and capital letters.\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryUnicef_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b7b2af2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryUnicef_vue__ = __webpack_require__(127);
function injectStyle (ssrContext) {
  __webpack_require__(126)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b7b2af2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SummaryUnicef_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b7b2af2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryUnicef_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"unicef"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"buttons-row"},[_vm._m(1),_vm._v(" "),_c('router-link',{staticClass:"opaque-blue",attrs:{"tag":"button","type":"button","name":"button","to":"/share-results"}},[_vm._v("\n      Dalej\n    ")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("\n      Podpisz apel UNICEF Polska do Ministra Zdrowia\n      i pomóż chronić dzieci przed groźnymi chorobami zakaźnymi!\n    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("\n        UNICEF Polska apeluje o:\n      ")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("\n        wspieranie rodziców w dostępie do wiarygodnych informacji na temat szczepień,\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        walkę z dezinformacją w mediach i przekłamywaniem informacji na temat szczepień,\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        aktywną promocję Programu Szczepień Ochronnych.\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"targt":"_blank","href":"https://unicef.pl/chce-pomoc/podpisz-apel/spadek-liczby-szczepien?utm_source=Demagog&utm_medium=quiz&utm_campaign=apel_szczepienia"}},[_c('button',{staticClass:"opaque-blue",attrs:{"type":"button","name":"button"}},[_vm._v("Podpisz apel")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareResults_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f9ecd7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareResults_vue__ = __webpack_require__(130);
function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f9ecd7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f9ecd7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container content-container",attrs:{"id":"share-results"}},[_c('div',[_c('h1',[_vm._v("THANKS FOR JOINING US")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"share-button",attrs:{"type":"button","name":"share-results"},on:{"click":function($event){_vm.shareResults()}}},[_c('img',{attrs:{"src":"static/img/fb.svg","alt":""}}),_vm._v(" "),_c('span',[_vm._v("Share")])]),_vm._v(" "),_c('div',{staticClass:"rating",class:{ rated: _vm.rated }},[_c('div',{staticClass:"rating-group"},[_vm._l((5),function(index){return [_c('label',{key:'label-'+index,staticClass:"rating__label",attrs:{"for":'rating-'+index}},[_c('div',{staticClass:"rating__icon rating__icon--star"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"48.863","height":"46.513","viewBox":"0 0 48.863 46.513"}},[_c('path',{attrs:{"data-name":"Path 224","d":"M48.824 17.687a.788.788 0 00-.637-.537l-15.926-2.314L25.141.404a.82.82 0 00-1.413 0l-7.127 14.432L.675 17.151a.788.788 0 00-.438 1.344L11.764 29.73l-2.72 15.863a.788.788 0 001.143.831l14.244-7.49 14.245 7.487a.788.788 0 001.143-.831l-2.718-15.86 11.525-11.235a.788.788 0 00.198-.808z","fill":"#dee6ea"}})])])]),_vm._v(" "),_c('input',{key:'input-'+index,staticClass:"rating__input",attrs:{"id":'rating-'+index,"name":"rating","type":"radio"},domProps:{"value":index,"checked":index == 5}})]})],2)]),_vm._v(" "),(!_vm.rated)?_c('button',{staticClass:"opaque-blue",attrs:{"type":"button","name":"button"},on:{"click":function($event){_vm.sendRate()}}},[_vm._v("\n      Submit\n    ")]):_vm._e(),_vm._v(" "),(_vm.rated)?_c('p',[_vm._v("\n      Thank you!\n    ")]):_vm._e()]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Share this game with your friends on Facebook and let us know how many stars you think it deserves :)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons"},[_c('h3',[_vm._v("\n      HUNGRY FOR MORE?\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Play the game once again or find out more about the origin of fake news!\n    ")]),_vm._v(" "),_c('div',{staticClass:"buttons-row"},[_c('a',{attrs:{"href":"/"}},[_c('button',{staticClass:"opaque-blue",attrs:{"type":"button","name":"button"}},[_vm._v("PLAY AGAIN")])]),_vm._v(" "),_c('a',{attrs:{"href":"https://demagog.org.pl","target":"_blank"}},[_c('button',{staticClass:"opaque-blue",attrs:{"type":"button","name":"button"}},[_vm._v("TELL ME MORE")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_quizes__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ping__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_manipulation_category__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_manipulation_category__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_quiz__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_quiz_setup_info__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_user__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_result_stats__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_topic_category__ = __webpack_require__(77);
















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    quiz: __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].create({ id: null }),
    user: __WEBPACK_IMPORTED_MODULE_11__data_user__["a" /* default */].create({ name: 'test' }),
    quizSetupInfo: __WEBPACK_IMPORTED_MODULE_10__data_quiz_setup_info__["a" /* default */].create({}),
    manipulationCategories: []
  },
  actions: {
    fetchManipulationCategories: function fetchManipulationCategories(context) {
      __WEBPACK_IMPORTED_MODULE_7__services_manipulation_category__["a" /* default */].fetchList().then(function (manipulationCategories) {
        context.commit('loadManipulationCategories', { manipulationCategories: manipulationCategories });
      });
    },
    generateQuiz: function generateQuiz(context) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var language, topicCategory, quiz, images;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                language = __WEBPACK_IMPORTED_MODULE_4__consts__["b" /* QUESTION_LANGUAGE */];
                topicCategory = __WEBPACK_IMPORTED_MODULE_10__data_quiz_setup_info__["a" /* default */].getTopicCategory(context.state.quizSetupInfo);
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_quizes__["a" /* generateQuiz */])({ topicCategory: topicCategory, language: language });

              case 4:
                quiz = _context.sent;
                _context.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_quizes__["b" /* loadQuizImages */])(quiz);

              case 7:
                images = _context.sent;

                context.commit('loadQuiz', {
                  quiz: quiz, images: images
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    pingBackend: function pingBackend() {
      Object(__WEBPACK_IMPORTED_MODULE_6__services_ping__["a" /* ping */])();
    }
  },
  mutations: {
    loadQuiz: function loadQuiz(state, _ref) {
      var quiz = _ref.quiz;

      state.quiz = quiz;
    },
    loadManipulationCategories: function loadManipulationCategories(state, _ref2) {
      var manipulationCategories = _ref2.manipulationCategories;

      state.manipulationCategories = manipulationCategories;
    },
    answerQuizQuestion: function answerQuizQuestion(state, _ref3) {
      var answer = _ref3.answer;

      __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].answerQuestion(state.quiz, answer);
    },
    omitQuizQuestion: function omitQuizQuestion(state) {
      __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].omitQuestion(state.quiz);
    },
    setUserInfo: function setUserInfo(state, userInfo) {
      __WEBPACK_IMPORTED_MODULE_11__data_user__["a" /* default */].setName(state.user, userInfo.name);
      var topicCategory = null;
      if (userInfo.category && userInfo.category !== 'all') {
        topicCategory = __WEBPACK_IMPORTED_MODULE_13__data_topic_category__["a" /* default */].fromName(userInfo.category);
      }
      __WEBPACK_IMPORTED_MODULE_10__data_quiz_setup_info__["a" /* default */].setValues(state.quizSetupInfo, {
        topicCategory: topicCategory,
        correctnessEstimate: userInfo.prediction / 100
      });
    }
  },
  getters: {
    isQuizLoaded: function isQuizLoaded(state) {
      return !!__WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].getId(state.quiz);
    },
    manipulationCategories: function manipulationCategories(state) {
      return state.manipulationCategories;
    },
    manipulationCategoriesMap: function manipulationCategoriesMap(state) {
      return __WEBPACK_IMPORTED_MODULE_8__data_manipulation_category__["a" /* default */].mapFromList(state.manipulationCategories);
    },
    currentQuizQuestion: function currentQuizQuestion(state) {
      return __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].getCurrentQuestion(state.quiz);
    },
    quizQuestions: function quizQuestions(state) {
      return __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].getQuestions(state.quiz);
    },
    quizQuestionIndex: function quizQuestionIndex(state) {
      return __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].getQuestionIndex(state.quiz);
    },
    numOfQuizQuestions: function numOfQuizQuestions(state) {
      return __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].getQuestions(state.quiz).length;
    },
    isQuizFinished: function isQuizFinished(state) {
      return __WEBPACK_IMPORTED_MODULE_9__data_quiz__["a" /* default */].isFinished(state.quiz);
    },
    resultStats: function resultStats(state) {
      var quiz = state.quiz,
          user = state.user,
          quizSetupInfo = state.quizSetupInfo,
          manipulationCategories = state.manipulationCategories;

      return __WEBPACK_IMPORTED_MODULE_12__data_result_stats__["a" /* default */].create({
        quiz: quiz,
        user: user,
        quizSetupInfo: quizSetupInfo,
        manipulationCategories: manipulationCategories
      });
    }
  }
}));

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateQuiz; });
/* harmony export (immutable) */ __webpack_exports__["b"] = loadQuizImages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_quiz__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_topic_category__ = __webpack_require__(77);









function parseQuestion(data) {
  return __WEBPACK_IMPORTED_MODULE_5__data_question__["a" /* default */].create({
    newsId: data.news_id,
    imageUrl: data.image_url,
    sourceName: data.source_name,
    sourceUrl: data.source_url,
    analysisName: data.analysis_name,
    analysisUrl: data.analysis_url,
    type: data.manipulation_category_name,
    answerExplanationHTML: data.answer_explanation_html,
    expectedAnswer: data.expected_answer
  });
}

function parseQuiz(data) {
  return __WEBPACK_IMPORTED_MODULE_4__data_quiz__["a" /* default */].create({
    id: data.id,
    questions: (data.questions || []).map(parseQuestion)
  });
}

var generateQuiz = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var _ref2$topicCategory = _ref2.topicCategory,
        topicCategory = _ref2$topicCategory === undefined ? null : _ref2$topicCategory,
        _ref2$language = _ref2.language,
        language = _ref2$language === undefined ? null : _ref2$language;
    var data, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = {};

            if (Object({"NODE_ENV":"production","BUILD_ENV":"production","GOOGLE_ANALYTICS_TRACKER_ID":"UA-156092120-1","BACKEND_HOST":"fzw-backend.herokuapp.com","BACKEND_HTTP_SCHEME":"https","APP_HOST":"aplikacja.fajniezewiesz.pl","APP_HTTP_SCHEME":"https"}).NUM_OF_QUIZ_QUESTIONS) {
              data['num_of_questions'] = Object({"NODE_ENV":"production","BUILD_ENV":"production","GOOGLE_ANALYTICS_TRACKER_ID":"UA-156092120-1","BACKEND_HOST":"fzw-backend.herokuapp.com","BACKEND_HTTP_SCHEME":"https","APP_HOST":"aplikacja.fajniezewiesz.pl","APP_HTTP_SCHEME":"https"}).NUM_OF_QUIZ_QUESTIONS;
            }
            if (topicCategory) {
              data['topic_category_name'] = __WEBPACK_IMPORTED_MODULE_6__data_topic_category__["a" /* default */].getName(topicCategory);
            }
            if (language) {
              data['language'] = language;
            }
            _context.next = 6;
            return __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].post('quiz/', data);

          case 6:
            response = _context.sent;
            return _context.abrupt('return', parseQuiz(response.data));

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function generateQuiz(_x) {
    return _ref.apply(this, arguments);
  };
}();

function loadImageByUrl(url) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var img = new Image();
    img.onload = function () {
      return resolve(img);
    };
    img.onerror = function () {
      return reject(new Error('Image ' + url + ' could not be loaded'));
    };
    img.src = url;
  });
}

function loadQuizImages(quiz) {
  var questions = __WEBPACK_IMPORTED_MODULE_4__data_quiz__["a" /* default */].getQuestions(quiz);
  var imageUrls = questions.map(__WEBPACK_IMPORTED_MODULE_5__data_question__["a" /* default */].getImageUrl);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(imageUrls.map(loadImageByUrl));
}

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(66);


function ping() {
  return __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */].get('ping/').then(function (response) {
    return response.data.message;
  });
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__ = __webpack_require__(17);



function fetchList() {
  // TODO: move to external REST API
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    resolve([__WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].create({
      name: 'clickbait'
    }), __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].create({
      name: 'fake-news'
    }), __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].create({
      name: 'image-manipulation'
    }), __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].create({
      name: 'emotional-language'
    })]);
  });
}

function fetchMap() {
  return fetchList().then(function (categories) {
    return __WEBPACK_IMPORTED_MODULE_1__data_manipulation_category__["a" /* default */].mapFromList(categories);
  });
}

var ManipulationCategoryService = {
  fetchList: fetchList,
  fetchMap: fetchMap
};

/* harmony default export */ __webpack_exports__["a"] = (ManipulationCategoryService);

/***/ })
],[78]);


// WEBPACK FOOTER //
// static/js/app.80b5f31577a389e37cde.js